"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EmpoweringEducationalExcellence() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="25078" id="architects-of-efficiency" ref={sectionRef} className="relative w-full overflow-hidden dark bg-background text-foreground py-20 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16 items-center">
          {}
          <div className={`lg:col-span-6 flex flex-col gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <h1 className="font-sans text-5xl md:text-7xl lg:text-8xl font-bold leading-[1.05] text-foreground tracking-tighter">
              Architects of <br />
              {" "}
              <span className="relative inline-block text-transparent bg-clip-text bg-gradient-to-r from-primary to-emerald-400">
                Efficiency
                {}
                <svg className="absolute -bottom-2 left-0 w-full h-[0.3em] text-primary/30 -z-10 pointer-events-none" viewBox="0 0 200 20" preserveAspectRatio="none" fill="currentColor" aria-hidden="true">
                  <path d="M5,15 Q50,5 90,12 T190,8" stroke="currentColor" strokeWidth="8" fill="none" strokeLinecap="round" />
                </svg>
              </span>
            </h1>

            <p className="font-sans text-lg md:text-[20px] leading-relaxed text-muted-foreground max-w-xl">
              Lavers Business Consulting leverages over a decade of expertise to 
              streamline operations, slash overheads, and drive sustainable 
              revenue growth through precise architectural strategy and 
              results-driven management.
            </p>

            <div className="pt-4">
              <Button asChild size="lg" className="relative h-14 px-10 text-lg font-bold rounded-sm shadow-md transition-all hover:scale-105 bg-primary text-primary-foreground">
                <Link to="/ConsultationPage">
                  <span className="relative z-10 flex items-center gap-2">
                    Start Transformation
                    <ArrowRight className="h-5 w-5" />
                  </span>
                  {}
                  <span className="absolute inset-0 rounded-sm bg-primary opacity-20 animate-ping duration-[4000ms]" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className={`lg:col-span-6 relative transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <div className="relative aspect-[4/3] w-full overflow-hidden rounded-sm shadow-2xl">
              {}
              <div className="absolute inset-0 bg-primary/20 mix-blend-overlay z-10 pointer-events-none" />
              <div className="absolute inset-0 bg-gradient-to-tr from-background to-transparent z-10 pointer-events-none" />
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1601078/img/modern_tasmanian_architecture.png" alt="Modern Tasmanian architectural structure representing precision" className="h-full w-full object-cover transition-transform duration-1000 grayscale hover:grayscale-0 hover:scale-110" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -left-6 -z-10 h-full w-full rounded-sm border border-primary/20 bg-transparent" />
          </div>
        </div>
      </div>
    </section>;
}